import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
//import awsconfig from './aws-exports';
import amplifyconfig from './amplifyconfiguration.json';
import { Amplify } from 'aws-amplify';
//import { Analytics } from 'aws-amplify';
//Analytics.disable();
//Amplify.configure(awsconfig);
//Amplify.configure(amplifyconfig);

// const awsmobile = {
//   aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS"
// };
// Amplify.configure(awsmobile);

/*var hostedUI = localStorage.getItem("amplify-signin-with-hostedUI");
if(!hostedUI || hostedUI == "true"){
  var samluserPool = environment.userPool.find(x => x.domain === "openid");
  if(samluserPool) {
    Amplify.configure(samluserPool);
  }else{
    var userPool = environment.userPool.find(x => x.domain === "carematch");
    Amplify.configure(userPool);
  }
}*/

// Amplify.configure({
//   API: {
//     graphql_headers: async () => ({
//       'Referrer-Policy': 'no-referrer',
//       'Cache-Control':  'no-cache, no-store, must-revalidate',
//       'Pragma': 'no-cache'
//     })
//   }
// });
// Amplify.configure({
//   API: {
//     GraphQL: {
//       endpoint: 'https://xug4ifclpfdvbmagbnxj6tr6he.appsync-api.us-east-1.amazonaws.com/graphql',
//       region: 'us-east-1',
//       // Set the default auth mode to "userPool"
//       defaultAuthMode: 'userPool',
//     }
//   }
// });

Amplify.configure({
  ...amplifyconfig,
  API: {
    GraphQL: {
      endpoint: "https://xug4ifclpfdvbmagbnxj6tr6he.appsync-api.us-east-1.amazonaws.com/graphql",
      region: amplifyconfig.aws_appsync_region,
      defaultAuthMode: 'userPool',
    }
  }
}, {
  API: {
    GraphQL: {
      headers: async () => ({
        'Referrer-Policy': 'no-referrer',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache'
      })
    }
  }
});


if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.log(err));
